const { REACT_APP_ENV, REACT_APP_API_KEY, REACT_APP_AUTH_DOMAIN, REACT_APP_PROJECT_ID, REACT_APP_STORAGE_BUCKET, REACT_APP_MESSAGING_SENDER_ID, REACT_APP_ID, REACT_APP_MEASUREMENT_ID, REACT_APP_VAPID_KEY, REACT_APP_MOBILE_INTERFACE, REACT_APP_MOBILE_INTERFACE_IOS } = process.env;

export default {
    REACT_APP_ENV,
    REACT_APP_API_KEY,
    REACT_APP_AUTH_DOMAIN,
    REACT_APP_PROJECT_ID,
    REACT_APP_STORAGE_BUCKET,
    REACT_APP_MESSAGING_SENDER_ID,
    REACT_APP_ID,
    REACT_APP_MEASUREMENT_ID,
    REACT_APP_VAPID_KEY,
    MOBILE: {
        MOBILE_INTERFACE: REACT_APP_MOBILE_INTERFACE,
        MOBILE_INTERFACE_IOS: REACT_APP_MOBILE_INTERFACE_IOS,
    }
}